export enum TransactionalChannelsEnum {
    PUSH = 'push',
    EMAIL = 'email',
    BOTH = 'both',
}

export enum StreamDigestChannelsEnum {
    DAILY = 'daily',
    WEEKLY = 'weekly',
    BOTH = 'both',
}

export enum TransactionalTriggersEnum {
    emailOpen =  "emailOpen",
    linkClicked=  "linkClicked",
    collectionViewed= "collectionViewed",
    assetViewed = "assetViewed",
    assetDownload = "assetDownload",
    reshare =  "reshare",
    doNotDisturb = "doNotDisturb",
    leadCaptured = "leadCaptured",
}

export enum DigestTriggersEnum {
    followerEmailDigestEnabled =  "followerEmailDigestEnabled",
    weekEmailDigestEnabled=  "weekEmailDigestEnabled",
    emailDigestEnabled= "emailDigestEnabled",
}


export const streamDigestChannels = [
    StreamDigestChannelsEnum.BOTH,
    StreamDigestChannelsEnum.DAILY,
    StreamDigestChannelsEnum.WEEKLY, 
];

export const transactionalChannels = [
    TransactionalChannelsEnum.BOTH, 
    TransactionalChannelsEnum.PUSH, 
    TransactionalChannelsEnum.EMAIL
];

export const TransactionalTriggersLabels = {
    [TransactionalTriggersEnum.emailOpen]:{
        title: 'Email Opened',
        subText: "Get notified when a recipient opens your email."
    },
    [TransactionalTriggersEnum.linkClicked]:{
        title: 'Link Clicked',
                subText: "Get notified when a recipient clicks a shared link."
    },
    [TransactionalTriggersEnum.assetViewed]:{
        title: 'Asset Viewed',
                subText: "Get notified when a recipient views a shared asset."
    },
    [TransactionalTriggersEnum.assetDownload]:{
        title: 'Asset Download',
                subText: "Get notified when a recipient downloads an asset."
    },
    [TransactionalTriggersEnum.collectionViewed]:{
        title: 'Collection Viewed',
                subText: "Get notified when a recipient views a shared collection."
    },
    [TransactionalTriggersEnum.reshare]:{
        title: 'Content Reshared',
                subText: "Get notified when your content is reshared with others."
    },
    [TransactionalTriggersEnum.leadCaptured]:{
        title: 'Lead Captured',
                subText: "Get notified when a new lead is captured from your content."
    },
}


export type Notification = {
    emailDigestEnabled?: boolean;
    followerEmailDigestEnabled?: boolean;
    weekEmailDigestEnabled?: boolean;
    email?: {
        emailOpen?: boolean;
        linkClicked?: boolean;
        collectionViewed?: boolean;
        assetViewed?: boolean;
        assetDownload?: boolean;
        reshare?: boolean;
        doNotDisturb?: boolean;
        leadCaptured?: boolean;
    };
    push?: {
        emailOpen?: boolean;
        linkClicked?: boolean;
        collectionViewed?: boolean;
        assetViewed?: boolean;
        assetDownload?: boolean;
        reshare?: boolean;
        doNotDisturb?: boolean;
        leadCaptured?: boolean;
    };
};
